import React from 'react'
import { Grid, TextField } from "@mui/material";
import { useField } from 'formik';

const TextFieldWrapper = ({
  name, 
  label,
  ...otherProps
}) => {
  const [field, meta] = useField(name);

  const configTextField = {
    ...field,
    ...otherProps,
    fullWidth: true,
    variant: 'outlined',
    size: 'small',
  }

  if (meta && meta.touched && meta.error) {
    configTextField.error = true;
    configTextField.helperText = meta.error;
  }

  return (
    <Grid
      item
      xs
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        marginTop: "16px",
      }}
    >
      <p>{label}</p>
      <TextField
        {...configTextField}
      />
    </Grid>
  )
}

export default TextFieldWrapper;